import { msg } from 'gt-react';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { EDI844AcknowledgementStatusSchema } from '@erp/rpc';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const ShipAndDebit844sPage = lazyRouteComponent(
  () => import('../844s/ShipAndDebit844sPage'),
  'ShipAndDebit844sPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/844-submissions',
  staticData: {
    app: {
      nav: {
        label: msg('844 Submissions', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 20,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SDTransaction },
        ],
      },
    },
  },
  component: ShipAndDebit844sPage,
  loader: () => ({
    crumb: msg('844 Submissions', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDTransaction,
    });
  },
  validateSearch: z.object({
    page: z.number().int().min(0).optional(),
    pageSize: z.number().int().optional().catch(undefined),
    submissionId: z.string().optional(),
    status: z.string().optional(),
    suppliers: z.array(z.string()).optional(),
    divisions: z.array(z.string()).optional(),
    sentDateFrom: z.string().optional(),
    sentDateTo: z.string().optional(),
    // Mirror the 844 RPC contract shapes so invalid URL params are rejected at
    // route parsing instead of being client-accepted then server-rejected.
    batchNumber: z.array(z.string().regex(/^\d+(-\d+)?$/)).optional(),
    deliveryMethod: z.enum(['edi', 'email']).optional(),
    acknowledgement:
      EDI844AcknowledgementStatusSchema.optional().catch(undefined),
    submissionNumbers: z.array(z.string().regex(/^\d+(-\d+)?$/)).optional(),
    vdmNumbers: z.array(z.string().regex(/^\d+(-\d+)?$/)).optional(),
  }),
});
